import clsx from 'clsx';
import { usePDPData, usePDPState } from '~/features/product-details/context';
import { Countdown } from '~/shared/components/Countdown';
import { useTranslation } from '~/shared/utils/translation';
import styles from './ProductPrelaunchCountdown.module.scss';

type Props = Omit<
    React.ComponentProps<typeof Countdown>,
    'endDate' | 'headline' | 'expiredText' | 'onExpire'
>;

// The logic for displaying product countdown lives in our context and is computed by `usePrelaunchGate`.
export const ProductPrelaunchCountdown: React.FC<Props> = ({ className, ...rest }) => {
    const { translate } = useTranslation();
    const { product } = usePDPData();
    const { isPrelaunchCountdownVisible } = usePDPState();

    if (!isPrelaunchCountdownVisible || !product.c_prelaunch) return null;

    return (
        <Countdown
            {...rest}
            className={clsx(styles.productPrelaunchCountdown, className)}
            endDate={product.c_prelaunch}
            headline={
                translate('pdp.countdown.prelaunch.headline') ||
                'Countdown til at tilbuddet frigives'
            }
            expiredText={translate('pdp.countdown.prelaunch.offerIsLive') || 'TILBUDDET ER LIVE'}
        />
    );
};
